var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

define(['jquery', 'core', 'app-common/component/service-call', 'app-common/component/api-call', 'view/report', 'component/report/transaction-view', 'component/report/transactions-table', 'component/report/pagination', 'component/report/overview-view', 'app-common/component/loader', 'component/report/editing', 'component/range-selector', 'lib/search-query-parser', 'moment', 'app-common/lib/jquery.velocity', 'common/lib/jquery.hotkeys'], function($, core, serviceCall, apiCall, ReportView, TransactionView, transactionsTable, PaginationMenuView, OverviewView, loader, editing, rangeSelector, searchQuery, moment) {
  /*
  # Provides a list of transactions and related functionality.
  #
  # When on click on each one, it'll open up the details of the transaction on the side.
  */

  var TransactionsReportView;
  return TransactionsReportView = (function(_super) {

    __extends(TransactionsReportView, _super);

    function TransactionsReportView() {
      TransactionsReportView.__super__.constructor.apply(this, arguments);
    }

    TransactionsReportView.prototype.transactionsTable = transactionsTable;

    TransactionsReportView.prototype.paginationMenu = new PaginationMenuView();

    TransactionsReportView.prototype.reportType = 'view';

    TransactionsReportView.prototype.initialLoad = true;

    /*
    # @param {Object} options contains id, title, icon, URL, template
    	    # @param {Array} params additional information passed to widget with ID
    */


    TransactionsReportView.prototype.initialize = function(options, params) {
      var pageIndex,
        _this = this;
      TransactionsReportView.__super__.initialize.apply(this, arguments);
      pageIndex = this.findPageNumIndex(params);
      if (pageIndex) {
        this.pageNum = params[pageIndex];
      }
      this.transactionView = new TransactionView(this.settings);
      this.transactionView.on('change', this.transactionViewChangeHandler.bind(this));
      this.overviewView = new OverviewView({
        hasFeature: this.hasFeature('overview')
      });
      this.transactionsTable.setRowClickCallback(this.rowClickCallback.bind(this));
      this.settings.transactionsUrl = options.url;
      this.settings.scrollSpeed = 500;
      this.settings.statusManage = false;
      this.data.items = [];
      this.initReportDateIntervals();
      this.refreshMetadata();
      return this.on('sidebar:maximized', function() {
        _this.hideTransaction();
        return _this.hideOverview();
      });
    };

    TransactionsReportView.prototype.initUI = function() {
      var _this = this;
      TransactionsReportView.__super__.initUI.apply(this, arguments);
      if (__indexOf.call(this.settings.features, 'edit') >= 0) {
        this.on('report:start-editing', function() {
          return _this.toggleEditing();
        });
      }
      this.on('report:before-load-transactions', this.beforeLoadTransactions);
      this.on('report:after-load-transactions', this.afterLoadTransactions);
      this.transactionsTable.initTransactionsReportTemplate($('.transactions-list'), [], this.getType(), function() {
        return _this.isCurrentReportFinished();
      });
      this.initBatchEditTools();
      editing.setCallback(function() {
        return _this.toggleEditing();
      });
      this.initTransactionsTableHotkeys();
      return this.updateReportStatus();
    };

    TransactionsReportView.prototype.initTransactionView = function() {
      var $target, data, transactionId;
      this.$el.find('.transaction-view__container').html(this.transactionView.$el);
      if ((transactionId = this.getUrlParamValue('transaction')) != null) {
        $target = this.transactionsTable.getTransactionRow(transactionId);
        if ($target.length > 0) {
          this.scrollIntoView($target);
        }
        data = this.transactionsTable.getTransactionData(transactionId);
        return this.showTransaction(data || {
          id: transactionId
        });
      } else {
        return this.hideTransaction();
      }
    };

    TransactionsReportView.prototype.initPagination = function() {
      var _this = this;
      this.paginationMenu.setElement($('.transactions-list__pagination')[0]);
      return this.paginationMenu.off('page-change').on('page-change', function(e) {
        core.trackEvent('Transactions List Pagination Clicked');
        return _this.loadPage(e.page);
      });
    };

    TransactionsReportView.prototype.initBatchEditTools = function() {
      $('.batch-edit').hide();
      this.insertLedgerSelector();
      this.attachSelectAllHandler();
      return this.attachBatchEditSubmitHandler();
    };

    TransactionsReportView.prototype.insertLedgerSelector = function() {
      var _ref;
      if ((_ref = core.getLedgersById()[this.data.currentLedgerId]) != null ? _ref.canBeEdited : void 0) {
        this.ledgerSelect = editing.getNewLedgerSelect();
        this.ledgerSelect.addClass("batch-edit-control");
        this.ledgerSelect.addClass("batch-edit");
        this.ledgerSelect.val(this.data.currentLedgerId);
        $('#batch-edit-ledger').html(this.ledgerSelect);
        return this.ledgerSelect.flexselect({
          sortAlphabetically: true
        });
      }
    };

    TransactionsReportView.prototype.attachSelectAllHandler = function() {
      return $('#batch-edit-select-all').on('change', function() {
        return $('.batch-edit-checkbox').prop('checked', $(this).prop('checked'));
      });
    };

    TransactionsReportView.prototype.attachBatchEditSubmitHandler = function() {
      var _this = this;
      return $('#batch-edit-submit').on('click', function() {
        var newCompany, newLedgerId, selectedLedgerId;
        selectedLedgerId = $('#batch-edit-ledger > input:hidden').val();
        newLedgerId = selectedLedgerId === _this.data.currentLedgerId ? null : selectedLedgerId;
        newCompany = $('#batch-edit-company').val() || null;
        return _this.transactionsTable.saveBatchEdit(newCompany, _this.data.currentLedgerId, newLedgerId, function(saveData) {
          return core.getRouter().refreshPage();
        });
      });
    };

    TransactionsReportView.prototype.findPageNumIndex = function(params) {
      var markerIndex;
      markerIndex = params.indexOf('page');
      if (markerIndex === -1 || isNaN(params[markerIndex + 1])) {
        return null;
      } else {
        return markerIndex + 1;
      }
    };

    TransactionsReportView.prototype.highlightRow = function(documentId) {
      return this.$el.find(".document_id_" + documentId).addClass('transactions-list__row--active');
    };

    TransactionsReportView.prototype.showTransaction = function(data, animate, updateUrl) {
      var $container;
      if (animate == null) {
        animate = true;
      }
      if (updateUrl == null) {
        updateUrl = true;
      }
      if (this.overviewView.isVisible()) {
        this.hideOverview();
      }
      this.transactionView.setData(data);
      this.highlightRow(data.id);
      if (updateUrl) {
        this.updateUrl({
          transaction: data.id
        });
      }
      $container = this.$el.find('.transactions-list__container');
      $container.css({
        'padding-right': '300px'
      });
      if (animate || !this.transactionView.isVisible()) {
        this.transactionView.show();
      }
      return this.minimizeSidebar();
    };

    TransactionsReportView.prototype.hideTransaction = function() {
      $('.transactions-list__container').velocity('stop').velocity({
        'padding-right': '0px'
      }, 200);
      this.transactionView.hide();
      this.maximizeSidebar();
      return this.removeUrlParam('transaction');
    };

    TransactionsReportView.prototype.remove = function() {
      var _ref, _ref1;
      TransactionsReportView.__super__.remove.apply(this, arguments);
      this.maximizeSidebar();
      if ((((_ref = this.settings) != null ? _ref.features : void 0) != null) && __indexOf.call(this.settings.features, 'edit') >= 0) {
        if (this.transactionsTable.isEdit()) {
          this.transactionsTable.hideEdit();
        }
        if (this.transactionsTable.isBatchEdit()) {
          this.transactionsTable.disableBatchEdit();
        }
      }
      this.transactionsTable.hide();
      if ((_ref1 = this.transactionView) != null) {
        _ref1.remove();
      }
      $(document).off('keydown.transactions-list');
      this.off('report:before-load-transactions');
      return this.off('report:after-load-transactions');
    };

    /*
    # Preparing data for transactions loading ajax call
    #
    # @param {number} toPage Page for loading
    # @param {boolean} searchMode Is search enabled
    # @return {Object} Object with parameters
    */


    TransactionsReportView.prototype.getQueryParamsForTransactionsLoading = function(toPage, searchMode) {
      var parameters, _ref;
      parameters = {
        page: parseInt(toPage || 1)
      };
      parameters['results-per-page'] = 50;
      if (this.hasFeature('date-range')) {
        _ref = this.getIntervalDates(true, true), parameters['from'] = _ref[0], parameters['to'] = _ref[1];
      }
      return parameters;
    };

    TransactionsReportView.prototype.getSearchUrl = function(params) {
      return this.settings.transactionsUrl(core.getCurrentClientId(), params['search-string'], params['page'], params['ledger-id'], params['from'], params['to']);
    };

    TransactionsReportView.prototype.getTransactionsUrl = function(params) {
      return this.settings.transactionsUrl(core.getCurrentClientId(), params['from'], params['to'], params['page'], params['ledger-id']);
    };

    TransactionsReportView.prototype.getQueryUrl = function(ledgerId, parameters, searchString) {
      var getUrl, isDateAfterMinimumDate, isDateFormatValid, isDateValid, keyword, minimumDate, options, queryKeyMap, queryUrl, searchParamExists, searchQueryObj, searchQueryObjKeys, searchValidationSuccessful, url, _i, _len;
      searchParamExists = false;
      queryUrl = ledgerId ? "query/json/" + (core.getCurrentClientId()) + "?ledger-id=" + ledgerId + "&from=" + parameters.from + "&to=" + parameters.to + "&page=" + parameters.page + "&results-per-page=50" : "query/json/" + (core.getCurrentClientId()) + "?from=" + parameters.from + "&to=" + parameters.to + "&page=" + parameters.page + "&results-per-page=50";
      minimumDate = '1999-12-31';
      isDateValid = true;
      isDateFormatValid = true;
      isDateAfterMinimumDate = true;
      options = {
        keywords: ['any', 'cc', 'cn', 'in', 'name', 'amount', 'ledger', 'after', 'before', 'more', 'less']
      };
      queryKeyMap = {
        any: 'any-note',
        cc: 'comment',
        cn: 'cat-note',
        "in": 'int-note',
        name: 'vendor',
        amount: 'amount-eq',
        more: 'amount-geq',
        less: 'amount-leq',
        ledger: 'ledger-name',
        after: 'from',
        before: 'to'
      };
      if (searchString != null) {
        searchString = $.trim(searchString.replace(/\s*:\s*/g, ":").replace(/\s+/g, ' ').replace(/'/g, '"').toLowerCase());
        parameters['search-string'] = searchString;
        searchQueryObj = searchQuery(searchString, options);
        searchQueryObjKeys = Object.keys(searchQueryObj);
        getUrl = function(keyword) {
          var queryKey, queryValue;
          if ($.inArray(keyword, options.keywords) > -1) {
            queryKey = queryKeyMap[keyword];
            queryValue = encodeURIComponent($.trim(searchQueryObj[keyword]));
            if ((queryKey === 'to') || (queryKey === 'from')) {
              queryValue = moment(queryValue, ["YYYY/MM/DD", "YYYY-MM-DD", "YYYYMMDD", "YYYY.MM.DD"]).format("YYYY-MM-DD");
              isDateFormatValid = (moment(queryValue).isValid()) && isDateFormatValid;
              isDateAfterMinimumDate = moment(queryValue).isAfter(minimumDate) && isDateAfterMinimumDate;
              isDateValid = isDateFormatValid && isDateAfterMinimumDate && isDateValid;
              if (isDateValid) {
                queryUrl = queryUrl.replace(parameters[queryKey], queryValue);
              }
            } else {
              queryUrl = queryUrl + ("&" + queryKey + "=" + queryValue);
            }
            return searchParamExists = true;
          }
        };
        for (_i = 0, _len = searchQueryObjKeys.length; _i < _len; _i++) {
          keyword = searchQueryObjKeys[_i];
          getUrl(keyword);
        }
      }
      searchValidationSuccessful = isDateValid;
      if (searchValidationSuccessful) {
        url = searchParamExists ? queryUrl : (searchString != null) && !searchParamExists ? (parameters['search-string'] = $.trim(parameters['search-string'].replace(/"|'/g, '')), decodeURIComponent(this.getSearchUrl(parameters))) : decodeURIComponent(this.getTransactionsUrl(parameters));
      } else {
        url = null;
        if (!isDateFormatValid) {
          this.showWrongDateFormatWarning();
        } else if (!isDateAfterMinimumDate) {
          this.showMinimumDateWarning();
        }
      }
      return url;
    };

    /*
    # Loading transactions according to settings.transactionsUrl property
    #
    # @param {number} toPage Page for loading
    # @param {string} searchString
    # @param {boolean} isLoadingAdditional is loading additional results (page > 1) or not
    */


    TransactionsReportView.prototype.loadData = function(toPage, searchString) {
      var ledgerId, parameters, url,
        _this = this;
      loader.init();
      parameters = this.getQueryParamsForTransactionsLoading(toPage, !!searchString);
      ledgerId = parameters['ledger-id'];
      if (searchString != null) {
        parameters['search-string'] = searchString;
        this.data.searchString = searchString;
      }
      if (this.settings.options.queryVals.searchkey != null) {
        url = this.getQueryUrl(ledgerId, parameters, encodeURIComponent(searchString));
      } else {
        url = this.getQueryUrl(ledgerId, parameters, searchString);
      }
      if (url != null) {
        this.trigger('report:before-load-transactions', parameters.page, searchString);
        this.loadingPromise = serviceCall('report', url, 'GET', null, 'json');
        this.addUnavailableMessage(this.loadingPromise);
        this.loadingPromise.done(function(data) {
          var transaction, _i, _len, _ref;
          if (!_this.UILoaded) {
            _this.initUI();
          }
          loader.hide();
          _ref = data.page.entries;
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            transaction = _ref[_i];
            _this.data.items.push(transaction);
          }
          _this.trigger('report:after-load-transactions', data, parameters.page, searchString);
          if (_this.data.items.length > 0 && _this.data.items.length === 1) {
            return _this.showTransaction(_this.data.items[0], true, false);
          }
        });
      }
      return loader.hide();
    };

    /*
    # @param {number} page Page for loading
    # @param {string} searchString
    */


    TransactionsReportView.prototype.beforeLoadTransactions = function(page, searchString) {};

    /*
    # @param {Object} data Loaded data
    # @param {number} page Page for loading
    # @param {string} searchString
    */


    TransactionsReportView.prototype.afterLoadTransactions = function(data, page, searchString) {
      var _ref;
      this.transactionsTable.setTransactions(data.page.entries);
      this.loadCommentCounts(data.page);
      this.loadCategorizerIndicator((_ref = data.page) != null ? _ref.entries : void 0);
      if (this.initialLoad) {
        this.initTransactionView();
        this.initOverviewView();
        this.initPagination();
        this.initialLoad = false;
      }
      this.highlightRow(this.transactionView.getId());
      this.paginationMenu.setPageCount(data.pageCount);
      this.paginationMenu.setPage(page);
      return core.trackEvent('Transactions List Viewed', {
        'pageCount': data.pageCount,
        'count': data.totalEntries
      });
    };

    TransactionsReportView.prototype.showMinimumDateWarning = function() {
      var minimumDate;
      minimumDate = '1999-12-31';
      return this.showNotification({
        type: 'warning',
        text: "Only dates after " + minimumDate + " are allowed"
      }, true);
    };

    TransactionsReportView.prototype.showWrongDateFormatWarning = function() {
      return this.showNotification({
        type: 'warning',
        text: 'Wrong date format detected. Use YYYYMMDD, YYYY-MM-DD, YYYY.MM.DD or YYYY/MM/DD'
      }, true);
    };

    TransactionsReportView.prototype.loadCommentCounts = function(data) {
      var documentIds,
        _this = this;
      documentIds = _.pluck(data.entries, 'id');
      return apiCall('comments', 'comment_count', 'POST', {
        objects: documentIds,
        clientId: core.getCurrentClientId()
      }).then(function(res) {
        return _this.displayCommentBadge(res);
      }).fail(function(err) {
        return console.error('Could not load comment counts: ', err);
      });
    };

    TransactionsReportView.prototype.loadCategorizerIndicator = function(entries) {
      var appendCountBadge, appendIconBadge, categorization, document, _i, _len, _ref, _ref1;
      if (entries == null) {
        entries = [];
      }
      appendIconBadge = function(entry, iconClassName) {
        var badge;
        badge = $("<div class=\"action-icon categorizer\"><div class=\"categorizer-badge\"><span class=\"ss-gizmo " + iconClassName + "\"></span></div></div>");
        return $(".document_id_" + entry.id + " .actions_column").append(badge);
      };
      appendCountBadge = function(entry, count) {
        var badge;
        badge = $("<div class=\"action-icon categorizer\"><div class=\"categorizer-badge\">" + count + "</div></div>");
        return $(".document_id_" + entry.id + " .actions_column").append(badge);
      };
      for (_i = 0, _len = entries.length; _i < _len; _i++) {
        document = entries[_i];
        categorization = (document != null ? document.categorization : void 0) || {};
        if (categorization != null ? categorization.selectedLedgerAccountId : void 0) {
          appendIconBadge(document, 'ss-check');
        } else if (categorization != null ? categorization.clientResponse : void 0) {
          appendIconBadge(document, 'ss-chat');
        } else if (categorization != null ? (_ref = categorization.suggestedLedgers) != null ? _ref.length : void 0 : void 0) {
          appendCountBadge(document, categorization != null ? (_ref1 = categorization.suggestedLedgers) != null ? _ref1.length : void 0 : void 0);
        }
      }
      return $('.action-icon:hidden').velocity('stop').velocity('transition.slideUpIn', {
        duration: 200,
        stagger: 100
      });
    };

    TransactionsReportView.prototype.displayCommentBadge = function(idToCount) {
      var $existingBadge, badge, key, stats, val;
      for (key in idToCount) {
        stats = idToCount[key];
        val = stats.commentCount;
        if (val > 0) {
          $existingBadge = $(".document_id_" + key + " .actions_column .comment-indicator").parent();
          if ($existingBadge.length > 0 && $existingBadge.find('.count').text() !== val) {
            $existingBadge.find('.count').text(val);
            continue;
          }
          badge = $("<div class=\"action-icon\"><span class=\"comment-indicator ss-gizmo ss-chat\"></span><span class=\"count\">" + val + "</span></div>").hide();
          $(".document_id_" + key + " .actions_column").append(badge);
        }
      }
      return $('.action-icon:hidden').velocity('stop').velocity('transition.slideUpIn', {
        duration: 200,
        stagger: 100
      });
    };

    /*
    # @param {number} page Page for loading
    */


    TransactionsReportView.prototype.loadPage = function(page) {
      var pageIndex, router, searchString;
      searchString = this.data.searchString || null;
      pageIndex = this.findPageNumIndex(this.settings.params);
      if (pageIndex === null) {
        this.settings.params.push('page');
        this.settings.params.push(page);
      } else {
        this.settings.params[pageIndex] = page;
      }
      router = core.getRouter();
      router.navigate(router.buildUrl(this.getType(), this.settings.params, this.settings.options));
      return this.loadData(page, searchString);
    };

    TransactionsReportView.prototype.initEditFeature = function() {
      var _this = this;
      TransactionsReportView.__super__.initEditFeature.apply(this, arguments);
      $('.edit-button').click(function() {
        return _this.toggleEditing();
      });
      return $('.batch-edit-button').click(function() {
        return _this.toggleBatchEditing();
      });
    };

    TransactionsReportView.prototype.toggleEditing = function() {
      var _this = this;
      if (this.isCurrentReportFinished()) {
        return;
      }
      if (this.transactionsTable.isEdit()) {
        loader.init();
        return this.transactionsTable.saveEdit(function(savedData) {
          var pageIndex;
          loader.hide();
          _this.editAction(savedData);
          savedData.forEach(function(data) {
            if (_this.transactionView.getId() === data.id) {
              return _this.transactionView.setData({
                id: data.id
              });
            }
          });
          _this.transactionsTable.disableEdit();
          pageIndex = _this.findPageNumIndex(_this.settings.params);
          return _this.loadData(_this.settings.params[pageIndex], _this.searchString);
        });
      } else {
        this.hideTransaction();
        this.exitBatchEditMode();
        return this.transactionsTable.enableEdit();
      }
    };

    TransactionsReportView.prototype.enterBatchEditMode = function() {
      this.hideTransaction();
      $('.batch-edit').show();
      $('#batch-edit-start-button').hide();
      $('#batch-edit-cancel-button').css('display', 'inline-block');
      this.transactionsTable.disableEdit();
      return this.transactionsTable.enableBatchEdit();
    };

    TransactionsReportView.prototype.exitBatchEditMode = function() {
      $('.batch-edit').hide();
      $('#batch-edit-cancel-button').hide();
      $('#batch-edit-start-button').show();
      return this.transactionsTable.disableBatchEdit();
    };

    TransactionsReportView.prototype.toggleBatchEditing = function() {
      if (this.isCurrentReportFinished()) {
        return;
      }
      if (this.transactionsTable.isBatchEdit()) {
        return this.exitBatchEditMode();
      } else {
        return this.enterBatchEditMode();
      }
    };

    TransactionsReportView.prototype.dateChangeAction = function() {
      TransactionsReportView.__super__.dateChangeAction.apply(this, arguments);
      this.updateReportURLFromInterval();
      this.loadData();
      return this.updateReportStatus();
    };

    /*
    # @param {string} searchKey
    */


    TransactionsReportView.prototype.searchAction = function(searchKey) {
      return this.searchLoad({
        queryVals: {
          returl: this.getType(),
          searchkey: searchKey
        }
      }, []);
    };

    TransactionsReportView.prototype.getReportTimeScaleByInterval = function(interval) {
      if (interval === 'YEAR') {
        return 'yearly';
      } else if (interval === 'QUARTER') {
        return 'quarterly';
      } else {
        return 'monthly';
      }
    };

    TransactionsReportView.prototype.rowClickCallback = function(e, data) {
      var $target;
      $target = $(e.currentTarget);
      if ($target.parent().hasClass('edit-mode')) {
        return;
      }
      if ($target.hasClass('delete_column')) {
        return;
      }
      if ($target.hasClass('show-document-entry')) {
        return;
      }
      if ($target.parent().hasClass('batch-edit-mode')) {
        $target.parent().toggleClass("batch-edit-highlight");
        $target.parent().find('.batch-edit-checkbox').click();
        return;
      }
      if ($target[0].nodeName.toLowerCase() === 'td') {
        this.$el.find('.transactions-list__row--active').removeClass('transactions-list__row--active');
        if (this.transactionView.isVisible() && data.id === this.transactionView.getId()) {
          return this.hideTransaction();
        } else if (!this.transactionsTable.isEdit()) {
          return this.showTransaction(this.transactionsTable.getTransactionData(data.id));
        }
      }
    };

    TransactionsReportView.prototype.initReportDateIntervals = function() {
      if (this.settings.params.length >= 4) {
        return this.updateReportIntervalFromURL(this.settings.params[1], this.settings.params[3]);
      } else {
        return this.updateReportURLFromInterval();
      }
    };

    TransactionsReportView.prototype.scrollIntoView = function($el) {
      var offset, visible_area_end, visible_area_start;
      offset = $el.offset().top;
      if (!$el.is(':visible')) {
        $el.css({
          visiblity: 'hidden'
        }).show();
        offset = $el.offset().top;
        $el.css({
          visiblity: "",
          display: ""
        });
      }
      visible_area_start = $(window).scrollTop();
      visible_area_end = visible_area_start + window.innerHeight;
      if (offset < visible_area_start || offset > visible_area_end) {
        return $('html,body').animate({
          scrollTop: offset - window.innerHeight / 3
        }, 10);
      }
    };

    TransactionsReportView.prototype.isEditHotkeyAllowed = function() {
      return !this.transactionView.isVisible() && !editing.isActive();
    };

    TransactionsReportView.prototype.initTransactionsTableHotkeys = function() {
      var upAndDownHandler,
        _this = this;
      upAndDownHandler = function(e) {
        var $activeRow, $row, $target, animation, data, transactionId, _ref;
        if ($(".comments-display__reply-input").is(":focus")) {
          return;
        }
        e.preventDefault();
        $activeRow = ($row = this.$el.find('.transactions-list__row--active')).length > 0 ? $row : $('.transactions-list__row').first();
        _ref = e.data === 'up' ? [$activeRow.prevAll(':visible').first(), 'transition.slideDownIn'] : e.data === 'down' ? [$activeRow.nextAll(':visible').first(), 'transition.slideUpIn'] : void 0, $target = _ref[0], animation = _ref[1];
        if ($target.length > 0 && !this.transactionView.editMode) {
          $activeRow.removeClass('transactions-list__row--active');
          this.transactionView.$el.velocity('stop').velocity(animation, 500);
          this.scrollIntoView($target);
          if (!this.transactionsTable.isEdit()) {
            transactionId = $target.attr('id').split('_')[2];
            data = this.transactionsTable.getTransactionData(transactionId);
            return this.showTransaction(data, false);
          }
        }
      };
      $(document).on('keydown.transactions-list', null, 'down', upAndDownHandler.bind(this));
      $(document).on('keydown.transactions-list', null, 'up', upAndDownHandler.bind(this));
      return $(document).on('keydown.transactions-list', null, 'esc', function(e) {
        e.preventDefault();
        _this.hideTransaction();
        return _this.hideOverview();
      });
    };

    TransactionsReportView.prototype.getFeatureElement = function(feature) {
      return $("." + feature + "-feature").parent('.control-button');
    };

    TransactionsReportView.prototype.initBackButtonFeature = function(title, path) {
      var _this = this;
      return this.$el.find('.back-feature').append(title).show().on('click', function() {
        return core.getRouter().loadPage(path);
      });
    };

    TransactionsReportView.prototype.transactionViewChangeHandler = function(e) {
      this.transactionsTable.updateTransactionData(e.data.id, e.data);
      this.loadCommentCounts({
        entries: [
          {
            id: e.data.id
          }
        ]
      });
      return this.loadCategorizerIndicator([this.transactionsTable.getTransactionData(e.data.id)]);
    };

    TransactionsReportView.prototype.updateReportStatus = function() {
      var Statuses, finishedDate, intervalMonths, metadata, month, monthStatus, reportStatus, statusForUI, statusFound, _i, _len;
      Statuses = rangeSelector.Status;
      intervalMonths = _.map(rangeSelector.getIntervalAsMonths(), function(month) {
        return {
          date: month
        };
      });
      finishedDate = null;
      statusFound = {};
      for (_i = 0, _len = intervalMonths.length; _i < _len; _i++) {
        month = intervalMonths[_i];
        metadata = _.findWhere(this.data.metadata, {
          date: month.date
        });
        monthStatus = metadata ? metadata.status : Statuses.INPROGRESS;
        statusFound[monthStatus] = true;
        finishedDate = Math.max(finishedDate, metadata != null ? metadata.updateDate : void 0);
      }
      reportStatus = Statuses.CLOSED;
      if (statusFound[Statuses.INPROGRESS]) {
        reportStatus = Statuses.INPROGRESS;
      } else if (statusFound[Statuses.FINISHED]) {
        reportStatus = Statuses.FINISHED;
      }
      statusForUI = reportStatus !== rangeSelector.Status.CLOSED ? 'status-in-progress' : 'status-finished';
      this.$el.removeClass('status-in-progress status-finished');
      this.$el.addClass(statusForUI);
      if (this.isCurrentReportFinished()) {
        this.hideEditingControls();
      } else {
        this.showEditingControls();
      }
      return [reportStatus, finishedDate];
    };

    TransactionsReportView.prototype.refreshMetadata = function() {
      var promise,
        _this = this;
      promise = serviceCall('report', "report/metadata.json/client/" + (core.getCurrentClientId()), 'GET');
      promise.then(function(res) {
        var _ref;
        return (_ref = _this.data) != null ? _ref.metadata = res : void 0;
      });
      return promise;
    };

    TransactionsReportView.prototype.hasClosedReports = function() {
      return this.hasClosedReportsIn(this.data.metadata);
    };

    TransactionsReportView.prototype.hasClosedReportsIn = function(data) {
      return _.filter(data, function(report) {
        return report.status === 'finished';
      }).length > 0;
    };

    TransactionsReportView.prototype.isCurrentReportFinished = function() {
      return this.$el.hasClass('status-finished');
    };

    TransactionsReportView.prototype.hideEditingControls = function() {
      return this.$el.find('#edit-ledgers, #batch-edit-start-button').addClass('disabled');
    };

    TransactionsReportView.prototype.showEditingControls = function() {
      return this.$el.find('#edit-ledgers, #batch-edit-start-button').removeClass('disabled');
    };

    TransactionsReportView.prototype.loadSpecificTransaction = function(transactionId) {
      var url,
        _this = this;
      url = "query/json/" + (core.getCurrentClientId()) + "?page=1&results-per-page=1&id=" + transactionId;
      this.loadingPromise = serviceCall('report', url, 'GET', null, 'json');
      this.addUnavailableMessage(this.loadingPromise);
      return this.loadingPromise.done(function(data) {
        var transaction, _i, _len, _ref;
        if (!_this.UILoaded) {
          _this.initUI();
        }
        loader.hide();
        _ref = data.page.entries;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          transaction = _ref[_i];
          _this.data.items.push(transaction);
        }
        _this.trigger('report:after-load-transactions', data, 1, null);
        if (_this.data.items.length > 0) {
          return _this.showTransaction({
            id: transactionId
          }, true, false);
        }
      });
    };

    TransactionsReportView.prototype.initOverviewView = function() {
      this.$el.find('.overview-view__container').html(this.overviewView.$el);
      if (this.getUrlParamValue('overview') === '') {
        return this.showOverview();
      } else {
        return this.hideOverview();
      }
    };

    TransactionsReportView.prototype.initOverviewFeature = function() {
      var _this = this;
      TransactionsReportView.__super__.initOverviewFeature.apply(this, arguments);
      return $('.overview-button').click(function() {
        return _this.toggleOverview();
      });
    };

    TransactionsReportView.prototype.showOverview = function() {
      var $container;
      $('#overview-show').hide();
      $('#overview-close').css('display', 'inline-block');
      $container = this.$el.find('.transactions-list__container');
      $container.velocity('stop').velocity({
        'margin-right': '300px'
      }, 200);
      this.overviewView.show(this.data.currentLedgerId);
      this.updateUrl({
        overview: ''
      });
      return this.minimizeSidebar();
    };

    TransactionsReportView.prototype.hideOverview = function() {
      $('#overview-close').hide();
      $('#overview-show').show();
      $('.transactions-list__container').velocity('stop').velocity({
        'margin-right': '0px'
      }, 200);
      this.overviewView.hide();
      this.removeUrlParam('overview');
      return this.maximizeSidebar();
    };

    TransactionsReportView.prototype.toggleOverview = function() {
      if (this.overviewView.isVisible()) {
        return this.hideOverview();
      } else {
        if (this.transactionView.isVisible()) {
          this.hideTransaction();
        }
        return this.showOverview();
      }
    };

    return TransactionsReportView;

  })(ReportView);
});
